const IP_ADDRESS_REGEX = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export default function isValidIpAddress(value: string): boolean {
  return IP_ADDRESS_REGEX.test(value);
}
